import type { IFooterViewModel } from "@/components/screens/login/types/login";

const LoginFooter = ({ vm }: { vm: IFooterViewModel }) => (
  <div className="mt-4 text-white">
    <h2 className="mb-2 font-bold ">{vm.labels.needHelpText}</h2>
    <span className="text-sm">
      {vm.labels.getInTouchText}
      <a
        href={vm.labels.supportLink}
        className="font-bold text-dines-green underline"
      >
        {vm.labels.teamText}
      </a>{" "}
      {vm.labels.orText}
      <a
        href={vm.labels.chatLink}
        className="font-bold text-dines-green underline"
        target="blank"
      >
        {vm.labels.chatToUsText}
      </a>{" "}
      {vm.labels.issuesText}
    </span>
  </div>
);

export default LoginFooter;
